import { render } from "./EventMonthCard.vue?vue&type=template&id=2f7ae6f7&ts=true"
import script from "./EventMonthCard.vue?vue&type=script&lang=ts"
export * from "./EventMonthCard.vue?vue&type=script&lang=ts"

import "./EventMonthCard.vue?vue&type=style&index=0&id=2f7ae6f7&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__